<div class="p-4 rounded-xl">

  <div class="flex justify-between mb-4">
    <h2 class="text-lg font-semibold">{{ 'SETUP.GEOGRAPHY.TITLE' | translate }}</h2>

    <button class="btn-primary" (click)="openPopup()">
      {{ 'SETUP.ADD_PLUS' | translate }}
    </button>
  </div>

  <app-table
    [columns]="columns"
    [data]="list"
    [actions]="actions"
  ></app-table>

  <app-popup
    [(show)]="showPopup"
    title="SETUP.GEOGRAPHY.TITLE"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    [readonly]="isViewMode"
    type="form"
  ></app-popup>

</div>